import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37bf0481"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  class: "modal fade",
  id: "modalEditSystemContact",
  role: "dialog"
}
const _hoisted_3 = { class: "modal-dialog modal-md" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "modal-title" }, "Kontakt bearbeiten"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal"
  }, "×")
], -1))
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "form-group row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label col-lg-2" }, "Name", -1))
const _hoisted_9 = { class: "col-lg-10" }
const _hoisted_10 = ["value", "disabled"]
const _hoisted_11 = { class: "modal-footer" }
const _hoisted_12 = { class: "font-weight-bold mb-4" }
const _hoisted_13 = {
  key: 0,
  class: "alert alert-warning",
  id: "alertSystemContacts"
}
const _hoisted_14 = { class: "text-right mb-3" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "media bg-white" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-3 align-self-center" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "btn bg-transparent border-blue text-blue rounded-pill border-2 btn-icon" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-user text-blue" })
  ])
], -1))
const _hoisted_19 = { class: "media-body align-self-center" }
const _hoisted_20 = { class: "font-weight-bold" }
const _hoisted_21 = { class: "text-muted" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "media-right align-self-center mr-1" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "btn bg-light" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-sort" })
  ])
], -1))
const _hoisted_23 = { class: "media-right align-self-center mr-1" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-user" }, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "media-right align-self-center" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-trash" }, null, -1))
const _hoisted_30 = [
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedEmployee) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (emp, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: emp.id,
                      disabled: _ctx.contacts.findIndex(item => item.id == emp.id) >= 0
                    }, _toDisplayString(emp.firstName) + " " + _toDisplayString(emp.lastName), 9, _hoisted_10))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.selectedEmployee]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              type: "button",
              class: "btn bg-success",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveSystemContact && _ctx.saveSystemContact(...args)))
            }, "Speichern")
          ])
        ])
      ])
    ]),
    _createElementVNode("h1", _hoisted_12, _toDisplayString(_ctx.headline) + " " + _toDisplayString(_ctx.systemId), 1),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        (_ctx.unsavedChanges)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Sie haben noch nicht gesicherte Daten. Bitte drücken Sie auf Daten sichern."))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("button", {
        id: "btn_modalAddContact",
        type: "button",
        class: "btn bg-primary mr-3",
        disabled: _ctx.contacts.length>=5,
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openContactModal && _ctx.openContactModal(...args)))
      }, _toDisplayString(_ctx.contacts.length) + "/5 Neuer Kontakt", 9, _hoisted_15),
      _createElementVNode("button", {
        type: "button",
        class: "btn bg-success",
        disabled: !_ctx.unsavedChanges,
        id: "btn_saveSystemContacts",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.saveSystemContacts && _ctx.saveSystemContacts(...args)))
      }, "Speichern", 8, _hoisted_16)
    ]),
    _createVNode(_component_draggable, {
      tag: "ul",
      list: _ctx.contacts,
      class: "media-list media-list-bordered",
      itemKey: "id",
      ghostClass: "ghost",
      onStart: _ctx.startDrag,
      onEnd: _ctx.onDrop,
      animation: "150"
    }, {
      item: _withCtx(({element}) => [
        _createElementVNode("li", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, _toDisplayString(element.firstName) + " " + _toDisplayString(element.lastName), 1),
            _createElementVNode("div", _hoisted_21, " Tel: " + _toDisplayString(element.tel), 1)
          ]),
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("button", {
              class: "btn bg-primary",
              onClick: ($event: any) => (_ctx.editSystemContact(element.id))
            }, _hoisted_26, 8, _hoisted_24)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("button", {
              class: "btn bg-danger",
              onClick: ($event: any) => (_ctx.deleteSystemContact(element.id))
            }, _hoisted_30, 8, _hoisted_28)
          ])
        ])
      ]),
      _: 1
    }, 8, ["list", "onStart", "onEnd"])
  ]))
}